(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["claude-spectralift-diodes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spectra-diodes-parallax')) {
    customElements.define('spectra-diodes-parallax', class SpectraDiodesParallax extends HTMLElement {
      connectedCallback() {
        this.section = this.querySelector('.spectraDiodes');
        this.figures = [...this.querySelectorAll('[data-parallax-speed]')];
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.active = false;
        this.frame = 0;
        this.onScroll = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => this.update());
        };
        this.onPreferenceChange = () => this.updateMode();

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            this.active = entry.isIntersecting;
            if (this.active) this.onScroll();
          }, { rootMargin: '20% 0px' });
          this.observer.observe(this);
        } else {
          this.active = true;
        }

        this.motionQuery.addEventListener('change', this.onPreferenceChange);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.updateMode();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.motionQuery?.removeEventListener('change', this.onPreferenceChange);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      updateMode() {
        const enabled = !this.motionQuery.matches;
        this.section.classList.toggle('spectraDiodes--parallax-ready', enabled);
        if (!enabled) {
          this.figures.forEach((figure) => {
            figure.querySelector('.spectraDiodes__image').style.transform = '';
          });
          return;
        }
        this.onScroll();
      }

      update() {
        this.frame = 0;
        if (!this.active || this.motionQuery.matches) return;

        const viewportHeight = window.innerHeight;
        this.figures.forEach((figure) => {
          const rect = figure.getBoundingClientRect();
          const progress = (rect.top + rect.height / 2 - viewportHeight / 2) / (viewportHeight + rect.height);
          const speed = Number(figure.dataset.parallaxSpeed || 0);
          const offset = Math.max(-Math.abs(speed), Math.min(Math.abs(speed), progress * speed * -3.2));
          figure.querySelector('.spectraDiodes__image').style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["claude-spectralift-skin-concerns"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spectra-concerns-parallax')) {
    customElements.define('spectra-concerns-parallax', class extends HTMLElement {
      connectedCallback() {
        this.section = this.querySelector('.spectraConcerns');
        this.classList.add('is-motion-ready');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.onScroll = this.onScroll.bind(this);
        this.onMotionChange = this.onMotionChange.bind(this);

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => this.setActive(entry.isIntersecting));
        }, { rootMargin: '120px 0px' });

        this.observer.observe(this);
        this.motionQuery.addEventListener('change', this.onMotionChange);
        this.onMotionChange();
      }

      disconnectedCallback() {
        this.setActive(false);
        this.observer?.disconnect();
        this.motionQuery?.removeEventListener('change', this.onMotionChange);
      }

      setActive(active) {
        if (this.active === active) return;
        this.active = active;
        window[active ? 'addEventListener' : 'removeEventListener']('scroll', this.onScroll, { passive: true });
        if (active) {
          this.classList.add('is-visible');
          this.onScroll();
        }
      }

      onMotionChange() {
        if (!this.section) return;
        if (this.motionQuery.matches) {
          this.section.style.setProperty('--sc-parallax-y', '0px');
          return;
        }
        this.onScroll();
      }

      onScroll() {
        if (!this.active || this.motionQuery.matches || this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          const rect = this.getBoundingClientRect();
          const viewportCenter = window.innerHeight / 2;
          const sectionCenter = rect.top + rect.height / 2;
          const progress = (sectionCenter - viewportCenter) / (window.innerHeight + rect.height);
          const offset = Math.max(-12, Math.min(12, progress * -28));
          this.section.style.setProperty('--sc-parallax-y', `${offset.toFixed(2)}px`);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
